export default class SeasonPass {
    constructor(api) {
        this.api = api;
        this.seasonPassClass = null;
    }

    async init(instance) {
        if (this.api && this.api.settings && this.api.settings.seasonPassInstance && this.api.settings.seasonPassInstance !== instance.instance) {
            return;
        }

        if (!this.seasonPassClass) {
            if (instance.data && instance.data.cdn && instance.data.cdn.js) {
                await this.api.util.loadJS(instance.data.cdn.js);
                // await this.api.util.loadJS(["http://localhost:8081/widget_seasonPass.js"]);
            } else if (
                this.api.settings &&
                this.api.settings.nativeMobileApp &&
                this.api.settings.widgetsUrl &&
                this.api.settings.widgetsUrl.seasonPass &&
                this.api.settings.widgetsUrl.seasonPass.js
            ) {
                await this.api.util.loadJS([this.api.settings.widgetsUrl.seasonPass.js]);
            }

            if (instance.data && instance.data.cdn && instance.data.cdn.css) {
                await this.api.util.loadCSS(instance.data.cdn.css);
                // await this.api.util.loadCSS(['http://localhost:63342/widgets/dist/seasonPass/css/seasonPass.css']);
            } else if (
                this.api.settings &&
                this.api.settings.nativeMobileApp &&
                this.api.settings.widgetsUrl &&
                this.api.settings.widgetsUrl.seasonPass &&
                this.api.settings.widgetsUrl.seasonPass.css
            ) {
                await this.api.util.loadCSS([this.api.settings.widgetsUrl.seasonPass.css]);
            }
        }

        if (window.store) {
            window.store.dispatch('addInstanceToContainer', instance.instance)
            this.createInstance(instance)
        }
    }

    createInstance(instance) {
        if (!document.getElementById(`ox-drawer-instance-container-${instance.instance}-inner`)) {
            setTimeout(()=> {
                this.createInstance(instance)
            },100)
        } else {
            this.seasonPassClass = new window.Widget_seasonPass.default(this.api.settings, `#ox-drawer-instance-container-${instance.instance}-inner`, instance.instance, this.api, instance.data && instance.data.settings);
        }
    }

    /**
     * `update close` ends the instance (season over, prototype switched off, module restricted).
     * The widget destroys itself; dropping the class here lets a later instanceAvailable - after a
     * reconnect, or a new season - build it again instead of being ignored as already created.
     */
    reset() {
        this.seasonPassClass = null;
    }
}
